
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/charging-electric-cars/card-request",
      function () {
        return require("private-next-pages/charging-electric-cars/card-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/charging-electric-cars/card-request"])
      });
    }
  